import { FC, useEffect, useState } from 'react';
import { leadsService } from 'services';
import { Table } from 'components';
import { Lead } from 'types';

const AdminPage: FC = () => {
  const [leads, setLeads] = useState<Lead[]>([]);

  const total = (leads: Lead[]) => {
    return leads.reduce((total: number, lead: Lead) => {
      return total + lead.persons;
    }, 0);
  };

  useEffect(() => {
    leadsService.fetchLeads().then((leads) => setLeads(leads));
  }, []);

  return (
    <>
      <p>Participants inscrits : {total(leads)}</p>
      <Table variant="leads" data={leads}/>
    </>
  );
};

export default AdminPage;